import { useState } from "react";

export default function District({
  district,
  district1,
  district2,
  setDistrict,
  setDistrict1,
  setDistrict2,
  defaultValue,
  errors,
}) {
  const [isSmall, setIsSmall] = useState(window.innerWidth <= 1000);
  const handleClick = (index) => {
    setDistrict(index);
    setDistrict1(null);
	  setDistrict2(null);// ❗ сброс второго
  };

  const handleClick1 = (index) => {
    setDistrict1(index);
    setDistrict(null);
	  setDistrict2(null);// ❗ сброс первого
  };

  const handleClick2 = (index) => {
    setDistrict2(index);
    setDistrict(null);
	  setDistrict1(null);// ❗ сброс первого
  };
  const options = [
    ["Center", "ԿԵՆՏՐՈՆ"],
    ["Arabkir", "ԱՐԱԲԿԻՐ"],
    ["Davtashen", "ԴԱՎԹԱՇԵՆ"],
    ["Ajapnyak", "ԱՋԱՓՆՅԱԿ"],
    ["Vahagni-district", isSmall ? "ՎԱՀԱԳՆԻ Թ." : "ՎԱՀԱԳՆԻ ԹԱՂԱՄԱՍ"],
    ["Kanaker-Zeytun", isSmall ? "ՔԱՆԱՔԵՌ-Զ." : "ՔԱՆԱՔԵՌ-ԶԵՅԹՈՒՆ"],
    ["Avan", "ԱՎԱՆ"],
    ["Nor-Norq", "ՆՈՐ ՆՈՐՔ"],
    ["Nork-Marash", "ՆՈՐՔ-ՄԱՐԱՇ"],
    ["Shengavit", "ՇԵՆԳԱՎԻԹ"],
    ["Malatia-Sebastia", isSmall ? "ՄԱԼԱԹԻԱ-Ս." : "ՄԱԼԱԹԻԱ-ՍԵԲԱՍՏԻԱ"],
    ["Erebuni", "ԷՐԵԲՈՒՆԻ"],
  ];
  const options1 = [
    ["Jrvej", "ՋՐՎԵԺ"],
    ["Zovuni", "ԶՈՎՈՒՆԻ"],
    ["Dzoraghpyur", "ՁՈՐԱՂԲՅՈՒՐ"],
    ["Ptghni", "ՊՏՂՆԻ"],
    ["Arzni", "ԱՐԶՆԻ"],
    ["Qasakh", "ՔԱՍԱԽ"],
    ["Nor-Geghi", "ՆՈՐ ԳԵՂԻ"],
    ["Nor-Hajn", "ՆՈՐ ՀԱՃՆ"],
    ["Tsakhkadzor", "ԾԱՂԿԱՁՈՐ"],
    ["Abovyan", "ԱԲՈՎՅԱՆ"],
    ["Proshyan", "ՊՌՈՇՅԱՆ"],
    ["Arinj", "ԱՌԻՆՋ"],
    ["Byureghavan", "Բյուրեղավան"],
    ["Yeghvard", "Եղվարդ"],
  ];
  const options2 = [["Dilijan", "ԴԻԼԻՋԱՆ"]]	

  return (
    <div
      className="district"
      style={{
        border: errors?.district ? "2px solid red" : "none",
        borderRadius: "10px",
      }}
    >
      <div>
        <h5>ՀԱՄԱՅՆՔ</h5>
        <div className="with">
          <p style={{ margin: 1, fontWeight: "bold" }}>ԵՐԵՎԱՆ</p>
          {options.map(([eng, arm], index) => (
            <div key={index}>
              <input
                type="radio"
                name="district"
                id={eng}
                value={eng}
                checked={
                  (district1 === null &&
                    district === null &&
			  district2 === null &&
                    eng === defaultValue) ||
                  (district === index)
                }
                onChange={() => handleClick(index)}
              />
              <label htmlFor={eng}>{arm}</label>
            </div>
          ))}
          <p style={{ margin: 1, fontWeight: "bold" }}>ԿՈՏԱՅՔ</p>
          {options1.map(([eng, arm], index) => (
            <div key={index}>
              <input
                type="radio"
                name="district"
                id={eng} // id лучше английский
                value={eng} // value английский
                checked={
                  (district1 === null &&
                    district === null &&
		    district2 === null &&
                    eng === defaultValue) ||
                  (district1 === index)
                }
                onChange={() => handleClick1(index)}
              />
              <label htmlFor={eng}>{arm}</label> {/* отображаем армянский */}
            </div>
          ))}
	  <p style={{ margin: 1, fontWeight: "bold" }}>ՏԱՎՈՒՇ</p>
          {options2.map(([eng, arm], index) => (
            <div key={index}>
              <input
                type="radio"
                name="district"
                id={eng} // id лучше английский
                value={eng} // value английский
                checked={
                  (district1 === null &&
                    district === null &&
		    district2 === null &&
                    eng === defaultValue) ||
                  (district2 === index)
                }
                onChange={() => handleClick2(index)}
              />
              <label htmlFor={eng}>{arm}</label> {/* отображаем армянский */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
